import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { LanguageProvider } from './context/LanguageContext';
import { MAINTENANCE_MODE } from './config/siteMode';

const Site = MAINTENANCE_MODE
  ? lazy(() => import('./pages/MaintenancePage.jsx'))
  : lazy(() => import('./App.jsx'));

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <LanguageProvider>
      <Suspense fallback={<div className="min-h-screen bg-cream" aria-hidden="true" />}>
        <Site />
      </Suspense>
    </LanguageProvider>
  </StrictMode>
);
